import { useState } from 'react';
import { Question } from '../../types';

interface UseQuestionOptionsProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function useQuestionOptions({ question, onEdit }: UseQuestionOptionsProps) {
  const [newOption, setNewOption] = useState('');
  const [isAddingOption, setIsAddingOption] = useState(false);

  const addOption = () => {
    if (newOption.trim()) {
      const currentOptions = question.options || [];
      onEdit(question.id, { options: [...currentOptions, newOption.trim()] });
      setNewOption('');
      setIsAddingOption(false);
    }
  };

  const cancelAddOption = () => {
    setNewOption('');
    setIsAddingOption(false);
  };

  const removeOption = (optionIndex: number) => {
    const currentOptions = question.options || [];
    onEdit(question.id, {
      options: currentOptions.filter((_, idx) => idx !== optionIndex),
    });
  };

  const updateOption = (optionIndex: number, newValue: string) => {
    const currentOptions = question.options || [];
    onEdit(question.id, {
      options: currentOptions.map((opt, idx) => (idx === optionIndex ? newValue : opt)),
    });
  };

  const reorderOptions = (startIndex: number, endIndex: number) => {
    const currentOptions = [...(question.options || [])];
    const [removed] = currentOptions.splice(startIndex, 1);
    if (removed) {
      currentOptions.splice(endIndex, 0, removed);
      onEdit(question.id, { options: currentOptions });
    }
  };

  return {
    newOption,
    isAddingOption,
    setNewOption,
    setIsAddingOption,
    addOption,
    cancelAddOption,
    removeOption,
    updateOption,
    reorderOptions,
  };
}
